import { render, staticRenderFns } from "./Agreement.vue?vue&type=template&id=4c053987&scoped=true"
import script from "./Agreement.vue?vue&type=script&lang=js"
export * from "./Agreement.vue?vue&type=script&lang=js"
import style0 from "./Agreement.vue?vue&type=style&index=0&id=4c053987&prod&lang=scss&scoped=true"
import style1 from "./Agreement.vue?vue&type=style&index=1&id=4c053987&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c053987",
  null
  
)

export default component.exports